import React from 'react';
import type { ComponentProps } from 'react';
import { components } from 'react-select';
import TopicNameWithIcon from './TopicNameWithIcon';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated';

const { SingleValue } = components;

const TOPIC_FRAGMENT = gql(`
  fragment TopicSelectValue_data_topic on Topic {
    id
    ...TopicNameWithIcon_topic
  }
`);

interface TopicSelectValueProps extends ComponentProps<typeof SingleValue> {
  data: {
    topic: DocumentType<typeof TOPIC_FRAGMENT>;
  };
}

const TopicSelectValue = (props: TopicSelectValueProps) => (
  <SingleValue {...props}>
    <TopicNameWithIcon topic={props.data.topic} />
  </SingleValue>
);

export default TopicSelectValue;
